(() => {
  if (window.PuzzlePupAnalytics) return;

  if (window.__ppInternalTraffic) {
    window.PuzzlePupAnalytics = Object.freeze({
      context: () => ({ traffic_type: 'internal' }),
      track: () => undefined
    });
    return;
  }

  const compact = payload => Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

  // Send only explicit, non-personal funnel fields. Never forward quiz answers,
  // names, email addresses, full URLs, free text, or commerce purchase events.
  const measuredEvents = /^(quiz_(view|start|step_view|email_view|answer|back|result|product_click|gallery_view|purchase_jump|quantity_selected|order_bump_changed|plan_selected|add_to_cart|add_to_cart_success|error|retake)|pp_(quiz_click|offer_impression|offer_accept|offer_reject|offer_removed_after_qualifier_change|package_select|purchase_type_select|frequency_select|add_to_cart|purchase_drawer_open|info_drawer_open|info_drawer_close|pdp_index_click|funnel_view|article_product_click))$/;
  const pendingMeasurements = [];
  const clean = value => typeof value === 'string' && /^[a-zA-Z0-9_ .:/-]{1,100}$/.test(value) ? value : null;
  function measurement(payload) {
    return {
      event_name: payload.event,
      page_type: clean(payload.page_type),
      page_path: window.location.pathname,
      funnel: clean(payload.funnel) || (window.location.pathname.includes('quiz') ? 'quiz' : 'storefront'),
      step: Number.isFinite(Number(payload.step)) ? Number(payload.step) : null,
      step_id: clean(payload.step_id),
      completed_questions: Number.isFinite(Number(payload.completed_questions)) ? Number(payload.completed_questions) : null,
      product_key: clean(payload.product_key),
      product_handle: clean(payload.product_handle),
      quantity: Number.isFinite(Number(payload.quantity)) ? Number(payload.quantity) : null,
      purchase_type: clean(payload.purchase_type),
      package: clean(payload.package),
      source: clean(payload.source),
      cta_location: clean(payload.cta_location),
      quiz_version: clean(payload.quiz_version)
    };
  }
  function sendMeasurement(payload) {
    if (!measuredEvents.test(payload.event)) return;
    const safe = measurement(payload);
    if (window.__ppAnalyticsConsent === null) {
      if (pendingMeasurements.length < 50) pendingMeasurements.push(safe);
    } else if (window.__ppAnalyticsConsent === true) {
      window.dataLayer.push({ event: 'pp_funnel_event', pp_measurement: safe });
    }
  }
  document.addEventListener('pp:analytics-consent', event => {
    const pending = pendingMeasurements.splice(0);
    if (event.detail?.allowed === true) pending.forEach(safe => window.dataLayer.push({ event: 'pp_funnel_event', pp_measurement: safe }));
  });

  function context(extra = {}) {
    const pdp = document.querySelector('[data-pp-v3-pdp]');
    const form = document.querySelector('[data-pp-canonical-form]');
    const packageInput = form?.querySelector('[data-pp-package]:checked');
    const purchaseInput = form?.querySelector('[data-pp-purchase-type]:checked');
    const sellingPlan = form?.querySelector('[data-pp-selling-plan]');
    const variant = form?.querySelector('[data-pp-variant-id]');
    return compact({
      page_type: document.querySelector('[data-pp-landing-v3]')
        ? 'landing'
        : (document.body?.dataset.template || window.meta?.page?.pageType || 'storefront'),
      product_id: pdp?.dataset.productId,
      variant_id: variant?.value || pdp?.dataset.variantId,
      product_type: pdp?.dataset.productType,
      product_handle: pdp?.dataset.productHandle,
      package: packageInput?.value,
      purchase_type: purchaseInput?.value || (sellingPlan?.value ? 'subscription' : 'one-time'),
      selling_plan_id: sellingPlan?.value,
      page_location: window.location.pathname,
      currency: window.Shopify?.currency?.active || 'USD',
      ...extra
    });
  }

  function track(eventName, payload = {}) {
    if (!eventName) return;
    const eventPayload = {
      event: eventName,
      event_id: `pp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      event_time: new Date().toISOString(),
      ...context(payload)
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);
    sendMeasurement(eventPayload);
    document.dispatchEvent(new CustomEvent('pp:analytics', { detail: eventPayload }));
    return eventPayload;
  }

  window.PuzzlePupAnalytics = Object.freeze({ context, track });
  track('pp_funnel_view');
  document.addEventListener('click', event => {
    const link = event.target.closest?.('article aside[aria-label="Related PuzzlePup product"] a[href*="/products/"]');
    if (link) track('pp_article_product_click', { source: 'article', cta_location: 'related_product' });
  });
})();
